export const platformFeedbackAPI="/platform-feedback";